import { getColumnTypes } from '../../../../api';

export const fetchRecordsAndHeaders = async (
  isExtract: boolean,
  tableInfo: any,
  datasetId: string,
  workspaceId: string,
  dbConnectionId: string,
  rowLevelCalcs: any,
) => {
  const res = await getColumnTypes(
    isExtract,
    dbConnectionId,
    datasetId,
    tableInfo,
    workspaceId,
    rowLevelCalcs,
    true,
  );

  return res as {
    isError: boolean;
    message: string;
    data: {
      columnName: string;
      dataType: string;
    }[];
  };
};
